import Responsive from '@/components/Responsive.vue'

export default {
  install (Vue) {
    Vue.component('Responsive', Responsive)

    Vue.mixin({
      computed: {
        responsive () {
          return this.$store.state.responsive
        }
      }
    })
  }
}
